export const T = {
  en_GB: {
    unit: "unit",
    units: "units",
  },
  nb_NO: {
    unit: "andel",
    units: "andeler",
  },
} as const;
